import { ReportSection } from '@app/components/reports/types';
import { SalesReportResultData } from '@shared/api/types';
import { useMemo } from 'react';
import { salesReportSlugs } from '../slugs';

export const salesReportUrls = {
  resultOverview: '#results-overview',
  emissionsOverTime: '#emissions-over-time',
  emissionsBySite: '#emissions-by-site',
  emissionsByCustomer: '#emissions-by-customer',
  emissionsByTag: '#emissions-by-tag',

  foodAndDrink: '#food-and-drink',
  emissionsByCategory: '#emissions-by-category',
  soldItemsFood: '#sold-items-food-and-drink',

  packaging: '#packaging',
  emissionsByMaterial: '#emissions-by-material',
  soldItemsPackaging: '#sold-items-packaging',
};

export function useSalesFormattedReportSections(
  reportSections: ReportSection[],
  result: SalesReportResultData
) {
  return useMemo(() => {
    if (!result) return [];
    return reportSections.reduce(
      (acc: ReportSection[], section: ReportSection) => {
        // Hide sections if data is not included in the report
        if (!result.includesFood || !result.foodAndDrink) {
          section.slug === salesReportSlugs.foodAndDrink &&
            (section.show = false);
        }

        if (!result.includesPackaging || !result.packaging) {
          section.slug === salesReportSlugs.packaging && (section.show = false);
        }

        section.show && acc.push(section);

        if (section.items && section.show) {
          section.items.forEach((subItem: ReportSection) => {
            if (subItem.slug === salesReportSlugs.emissionsOverTime) {
              result.emissionsOverTime.length < 2 && (subItem.show = false);
            }

            if (subItem.slug === salesReportSlugs.emissionsBySite) {
              result.emissionsBySite.filter((item) => item.name !== 'No site')
                .length < 2 && (subItem.show = false);
            }

            if (subItem.slug === salesReportSlugs.emissionsByCustomer) {
              result.emissionsByCustomer.filter(
                (item) => item.name !== 'No customer'
              ).length < 2 && (subItem.show = false);
            }

            if (subItem.slug === salesReportSlugs.emissionsByTag) {
              result.emissionsByTag.length < 2 && (subItem.show = false);
            }

            subItem.show && acc.push(subItem);
          });
        }

        return acc;
      },
      []
    ) as ReportSection[];
  }, [reportSections, result]);
}
